import { Disclosure } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import {
  IoIosArrowDown,
  IoIosArrowForward,
  IoIosArrowUp,
} from "react-icons/io";
import { Link, Outlet, useNavigate } from "react-router-dom";
import {
  ChangeTitle,
  decrypt,
  formatPrice,
  getEncodedCookie,
  selectStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { getCookie, setCookie } from "../../helpers/CookieComponent";
import Select from "react-select";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import { ToastContainer } from "react-toastify";

const Training = () => {
  ChangeTitle("Training");
  const [trainingList, setTrainingList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("INR");
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [currencyList, setCurrencyList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [countryService, setCountryService] = useState("");
  const [openIndex, setOpenIndex] = useState(null); // State to track which accordion is open
  const navigate = useNavigate();
  const auth = decrypt(getCookie("token")) || "";

  // Accordion open verify function
  const isOpen = (index) => openIndex === index;

  // Accordion toggle function
  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index)); // Toggle or close the accordion
  };

  // Book List API Call
  const viewTrainingList = async (taxserviceId, currency) => {
    const param = {
      offset: 0,
      limit: 0,
      taxserviceId: taxserviceId,
      currency: currency,
    };

    var response = await postData(
      "training/batchname/list",
      param,
      apiHeader(false)
    );
    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const bookData = data.map((data) => {
        return {
          id: data._id,
          title: data.batchName,
          price: data.fees,
          image: data.trainingImage,
          currency: data.defaultCurrency,
        };
      });
      setTrainingList(bookData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };
  // Currency API Call
  const viewCurrencyList = async () => {
    const param = {};
    // var response = await postData("country/list", param, apiHeader(false));
    var response = await postData("currency/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const currencyData = data.map((data) => {
        return {
          id: data._id,
          value: data.countryDetail.currency,
          label: `${data.countryDetail.currencyName} (${data.countryDetail.currencySymbol}) - ${data.countryDetail.currency}`,
          currencySymbol: data.countryDetail.currencySymbol,
          currency: data.countryDetail.currency,
        };
      });
      setCurrencyList(currencyData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Taxservice Countrywise API Call
  const viewCountryList = async () => {
    const param = {};

    var response = await postData(
      "taxservice/countrywise/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          id: data._id,
          countryName: data.countryName,
          taxservice: data.taxservice,
        };
      });
      setCountryList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Plan Buy Function
  const buyPlan = async (data) => {
    setCookie("t-planbillingId", data.id, {});

    const param = {
      trainingId: data.id,
      promoCode: "",
      currency: data.currency || "INR",
    };
    var response = await postData(
      "private/training/buy/preview",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      navigate("/training/billing");
    } else {
      toasterrormsg(response.data.message);
    }
  };

  useEffect(() => {
    viewTrainingList(countryService, selectedCountry);
  }, [countryService, selectedCountry]);

  useEffect(() => {
    viewCurrencyList();
    viewCountryList();
  }, []);
  useEffect(() => {
    setCookie("t-plan-currency", "INR", {});
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="w-full p-[5%] section-books">
        <div className="xxl:container mx-auto">
          <div className="flex relative z-[3] mb-[5%] justify-center items-center gap-5">
            <label className="currencylabel">Currency</label>
            <div className="w-[60%] md:w-[30%] currencyselect">
              <Select
                name="countryName"
                id="country"
                placeholder="Select Country"
                className="w-full cs-main"
                isSearchable={true}
                options={currencyList}
                value={currencyList.find(
                  (item) => item.value === selectedCountry
                )}
                onChange={(e) => {
                  setSelectedCountry(e.value);
                  setCurrencySymbol(e.currency);
                  setCookie("t-plan-currency", e.currency, {});
                }}
                styles={selectStyle}
              />
            </div>
          </div>
          <div className="w-full flex flex-col items-center lg:items-start lg:flex-row gap-10 sec-books">
            <div className="w-[90%] sm:w-[60%] lg:w-[25%] flex flex-col gap-5 sec-book-part1">
              {countryList.map((data, i) => (
                <div
                  className={
                    isOpen(i) ? "p-[2%] sbp1-box-active" : "p-[2%] sbp1-box"
                  }
                >
                  <button
                    onClick={() => toggleAccordion(i)}
                    className="flex w-full justify-between"
                  >
                    <span>{data.countryName}</span>
                    {isOpen(i) ? (
                      <IoIosArrowUp className="sbp1-up" />
                    ) : (
                      <IoIosArrowDown className="sbp1-down" />
                    )}
                  </button>
                  {isOpen(i) && (
                    <ul className="pl-[4rem] flex flex-col gap-5 px-4 pb-2 pt-4 book-country-ul">
                      {data.taxservice.map((data, i) => (
                        <li
                          onClick={() => setCountryService(data._id)}
                          className="text-start cursor-pointer book-country-ul-li"
                        >
                          {data.serviceName}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
            {trainingList.length > 0 && (
              <div className="lg:w-[75%] grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-y-[5rem] gap-x-[3rem] sec-book-part2">
                {trainingList.map((data, i) => (
                  <div className="w-full">
                    <div className="flex flex-col gap-5 items-center md:items-start w-full h-full sbp2-box">
                      <Link
                        to="/trainingdetails"
                        onClick={() => setCookie("trainingId", data.id, {})}
                        className="w-full"
                      >
                        <img
                          className="w-full aspect-square object-cover rounded-[2rem]"
                          src={data.image}
                          alt="Book Image"
                        />
                      </Link>
                      <Link
                        to="/trainingdetails"
                        onClick={() => setCookie("trainingId", data.id, {})}
                        className="sbp2-box-title"
                      >
                        {data.title}
                      </Link>
                      <h2 className="sbp2-box-price">
                        {selectedCountry} {data.price && formatPrice(data.price, selectedCountry)}
                      </h2>
                      <div className="w-full mt-auto flex gap-10 sbp2-box-btns">
                        <button
                          onClick={() => {
                            if (!auth) {
                              toasterrormsg("Please login first");
                              return false;
                            }
                            buyPlan(data);
                          }}
                          className="w-[50%] p-[4%] sbp2-box-btn2"
                        >
                          Buy
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {trainingList.length == 0 && (
              <h1 className="w-full lg:w-[75%] text-center no-found">
                No training found
              </h1>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Training;
